module.exports = __webpack_public_path__ + "img/f16.5d0ca6c3.jpg";